import { Resource as e } from "@coveo/platform-client";
//#region src/resources/ExportServiceResource.ts
var t = class t extends e {
	static {
		this.baseUrl = "/rest/ua/v15/exports";
	}
	exportsForSchedule(e, n) {
		return this.api.get(this.buildPathWithOrg(`${t.baseUrl}/schedules/${e}/exports`), n);
	}
	buildPathWithOrg(e, t) {
		return super.buildPath(e, {
			org: this.api.organizationId,
			...t
		});
	}
};
//#endregion
export { t as ExportServiceResource };

//# sourceMappingURL=ExportServiceResource.js.map